module.exports = __webpack_public_path__ + "static/media/memories-Logo.893f8b44.png";